// extracted by mini-css-extract-plugin
export default {"departments":"nE-z","departmentHeading":"oE-z","departmentSection":"pE-z","departmentName":"qE-z","departmentLink":"rE-z","expandIcon":"sE-z"};